import React from 'react';
import { Icon, type IconKind } from '../Icon/Icon';

export type GrowthIconKind = IconKind | 'store' | 'appgrid';

export interface GrowthIconProps {
  kind: GrowthIconKind;
  size?: number;
  stroke?: number;
  color?: string;
  className?: string;
}

export function GrowthIcon({ kind, size = 18, stroke = 1.7, color, className }: GrowthIconProps) {
  if (kind === 'store') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color ?? 'currentColor'}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M4 9.5 5.5 4h13L20 9.5" />
        <path d="M4 9.5h16v2a4 4 0 0 1-8 0 4 4 0 0 1-8 0z" />
        <path d="M5 13.5V20h14v-6.5" />
      </svg>
    );
  }

  if (kind === 'appgrid') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color ?? 'currentColor'}
        className={className}
      >
        {[5, 12, 19].map((y) =>
          [5, 12, 19].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="1.6" />),
        )}
      </svg>
    );
  }

  return <Icon kind={kind} size={size} stroke={stroke} {...(color ? { color } : {})} className={className} />;
}
